import { useEffect, useState } from 'react';

/**
 * True when the viewport is phone-sized (< 768px, Tailwind's `md` breakpoint).
 * Used to switch the calendar to the agenda (list) view on mobile.
 */
export const useIsMobile = (breakpoint = 768): boolean => {
    const query = `(max-width: ${breakpoint - 1}px)`;
    const [isMobile, setIsMobile] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(query).matches,
    );

    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
        setIsMobile(mql.matches);
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, [query]);

    return isMobile;
};

export default useIsMobile;
